<template lang="pug">
div.indice-container(@click.stop="stop")
    a.btn.btn-icon.indice-trigger(@click.stop="toggle")
        i.fa.fa-plus-circle
        | 自定义指标
    .q-custom-indices.form(v-show="visible")
        i.triangle
        .spread-indices(v-if="hasSpreadIndice")
            .label 推广指标：
            .control
              ul
                li(v-for="item in spread", :key="item[1]")
                  label(@click="changeIndice(item[0])")
                    span(:class="{checked: model[item[0]]}")
                    | {{item[1]}}
        .flux-indices
            .label 基础流量指标：
            .control
              ul
                li(v-for="item in flux", :key="item[1]")
                    label(@click="changeIndice(item[0])")
                        span(:class="{checked: model[item[0]]}")
                        | {{item[1]}}
        .quality-indices
            .label 流量质量指标：
            .control
              ul
                li(v-for="item in quality", :key="item[1]")
                    label(@click="changeIndice(item[0])")
                        span(:class="{checked: model[item[0]]}")
                        | {{item[1]}}
        .system-indices(v-if="hasSystemIndice")
            .label 系统转化指标：
            .control
              ul
                li(v-for="item in system", :key="item[1]")
                    label(@click="changeIndice(item[0])")
                        span(:class="{checked: model[item[0]]}")
                        | {{item[1]}}
                li
                  router-link(to="/setting/gencode", class="btn btn-primary btn-icon mgleft8", style="font-size: 12px;") 获取代码监测转化指标

        .conv-indices
          .label 自定义转化指标：
          .control
            ul
                li(v-for="item in trans", :key="item[1]")
                    label(@click="changeIndice(item[0])")
                        span(:class="{checked: model[item[0]]}")
                        | {{item[1]}}
                li
                  router-link(to="/setting/trans", class="btn btn-primary btn-icon mgleft8", style="font-size: 12px;") 手动设置转化指标
        div(style="overflow: hidden; font-weight: normal;")
            div(style="float: left;")
              | 当前已选中 {{checkedCount}} 项
              //| ，可同时选择 {{max}} 项
            div(style="float: left;")
                a.restore-btn.btn.btn-primary.btn-icon.mgleft8(@click="restoreIndices") 恢复默认指标
            a.btn.btn-default.btn-small.pull-right.mgTop4(type="button", @click.stop="cancel", style="margin-left: 10px") 取消
            a.btn.btn-primary.btn-small.pull-right.mgTop4(type="button", @click.stop="confirm", :disabled="checkedCount == 0") 确定

</template>

<script>
/* global _ */
const indiceMap = {
  spread: {
    adpv: '展现量',
    adclick: '点击量',
    adctr: '点击率',
    adcost: '消费',
    adcpc: 'CPC',
    adcpm: 'CPM'
  },
  flux: {
    pv: '浏览量(PV)',
    uv: '访客数(UV)',
    vnum: '访问次数',
    ipnum: 'IP',
    newvst: '新独立访客'
  },
  quality: {
    atime: '平均访问时长',
    anum: '平均访问页数',
    jrate: '跳出率'
  },
  system: {
    ordernum: '订单量',
    orderrate: '订单转化率',
    orderprice: '订单金额',
    reg: '注册量',
    regrate: '注册转化率'
  },
  trans: {
    tnum: '自定义转化次数 ',
    trate: '转化率'
  }
}

export default {
  props: {
    hasSpreadIndice: {
      type: Boolean,
      default: false
    },
    hasSystemIndice: {
      type: Boolean,
      default: false
    },
    // 由于需求变动暂时不需要判断最大值，通常只有20+，不会超过99
    max: {
      type: Number,
      default: 99
    },
    defaults: {
      type: Array,
      default () {
        return [
          'newvst',
          'atime',
          'tnum'
        ]
      }
    },
    spreadExtend: {
      type: Object,
      default () {
        return {}
      }
    },
    fluxExtend: {
      type: Object,
      default () {
        return {}
      }
    },
    qualityExtend: {
      type: Object,
      default () {
        return {}
      }
    },
    systemExtend: {
      type: Object,
      default () {
        return {}
      }
    },
    transExtend: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  watch: {
    defaults (newVal, oldVal) {
      this.defaults = newVal
      this.queue = _.cloneDeep(this.defaults)
      this._queue = _.cloneDeep(this.defaults)
      this.model = this.createModel(this.defaults)
      this._model = this.createModel(this.defaults)
    },
    hasSystemIndice () {
      this.$nextTick(() => {
        this.queue = _.cloneDeep(this.defaults)
        this._queue = _.cloneDeep(this.defaults)
        this.model = this.createModel(this.defaults)
        this._model = this.createModel(this.defaults)
      })
    }
  },
  data () {
    return {
      model: this.createModel(this.defaults),
      queue: _.cloneDeep(this.defaults),
      _queue: _.cloneDeep(this.defaults),
      _model: this.createModel(this.defaults),
      visible: false
    }
  },
  computed: {
    spread () {
      const spread = _.assignIn({}, indiceMap.spread, this.spreadExtend)
      return Object.keys(spread).map(k => [k, spread[k]])
    },
    flux () {
      const flux = _.assignIn({}, indiceMap.flux, this.fluxExtend)
      return Object.keys(flux).map(k => [k, flux[k]])
    },
    quality () {
      const quality = _.assignIn({}, indiceMap.quality, this.qualityExtend)
      return Object.keys(quality).map(k => [k, quality[k]])
    },
    system () {
      const system = _.assignIn({}, indiceMap.system, this.systemExtend)
      return Object.keys(system).map(k => [k, system[k]])
    },
    trans () {
      const trans = _.assignIn({}, indiceMap.trans, this.transExtend)
      return Object.keys(trans).map(k => [k, trans[k]])
    },
    checkedCount () {
      return _.keys(this.model).filter(key => this.model[key]).length
    }
  },
  methods: {
    createModel (defaults) {
      let keys = _.keys(indiceMap.flux).concat(_.keys(indiceMap.trans)).concat(_.keys(indiceMap.quality)).concat(_.keys(this.fluxExtend)).concat(_.keys(this.qualityExtend)).concat(_.keys(this.transExtend))
      if (this.hasSystemIndice) {
        keys = _.concat(keys, _.keys(indiceMap.system)).concat(_.keys(this.systemExtend))
      }
      if (this.hasSpreadIndice) {
        keys = _.concat(keys, _.keys(indiceMap.spread)).concat(_.keys(this.spreadExtend))
      }

      const model = keys.reduce((accu, key) => {
        accu[key] = false
        return accu
      }, {})

      defaults.forEach((key) => {
        if (key in model) {
          model[key] = true
        }
      })

      return model
    },
    restoreIndices () {
      this.model = this.createModel(this.defaults)
      this.queue = _.cloneDeep(this.defaults)
    },
    changeIndice (name) {
      const model = this.model
      const checked = model[name]
      if (checked || this.checkedCount < this.max) {
        model[name] = !checked
      } else if (this.checkedCount >= this.max) {
        model[this.queue.shift()] = false

        model[name] = true
      } else {
        model[name] = false
      }

      if (model[name]) {
        this.queue.push(name)
      } else {
        this.queue.splice(_.indexOf(this.queue, name), 1)
      }
    },
    save () {
      this._queue = _.cloneDeep(this.queue || this.defaults)
      this._model = _.cloneDeep(this.model || this.createModel(this.defaults))
    },
    restore () {
      this.queue = _.cloneDeep(this._queue || this.defaults)
      this.model = _.cloneDeep(this._model || this.createModel(this.defaults))
    },
    confirm () {
      if (this.checkedCount === 0) return
      this.visible = false
      this.save()
      this.$emit('change', this.queue.slice(0))
    },
    cancel () {
      this.visible = false
      this.restore()
    },
    toggle () {
      if (this.visible) {
        this.cancel()
      } else {
        this.visible = true
        this.save()
      }
    },
    stop () {}
  },
  mounted () {
    document.addEventListener('click', this.cancel)
  },
  destroyed () {
    document.removeEventListener('click', this.cancel)
  }
}
</script>

<style>
.indice-container {
    float: right;
    position: relative;
    margin-right: 14px;
    -webkit-user-select: none;
            user-select: none;
}
.q-custom-indices {
    position: absolute;
    right: 100%;
    bottom: 6px;
    padding: 15px;
    padding-bottom: 12px;
    margin-right: 5px;
    background: white;
    min-width: 605px;
    font-size: 12px;
    border: 1px solid #cdcbcb;
    box-shadow: 1px 1px 6px rgba(0,0,0,0.2);
    /****确保浮层在最上面******/
    z-index: 99999999;
}

.q-custom-indices > div {
    line-height: 3em
}

.q-custom-indices > div > label {
    width: 100px;
}

.q-custom-indices label,
.q-custom-indices li {
    display: inline-block
}

.q-custom-indices ul {
  display: block;
  margin-left: 100px;
}

.q-custom-indices li {
    margin-right: 1em
}

.q-custom-indices .control .btn {
  padding: 0;
}
.q-custom-indices button {
    width: 7em
}

.q-custom-indices .restore {
    margin-left: 1em;
    color: #56bf8b;
    text-decoration: none;
}
.q-custom-indices .restore:hover {
    color: #56bf8b;
    text-decoration: underline;
}
.restore-btn {
    font-size: 12px;
    vertical-align: baseline;
}

.q-custom-indices label {
    font-weight: normal;
    cursor: pointer;
}

.q-custom-indices label span {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin: -1px 4px 0 0;
    vertical-align: middle;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAElBMVEX////d4Ord4Ofd3+va4eje4OV0/av1AAAAO0lEQVQI12NwVTI2ElJScmUIYAADJgYFNAYLgwGEwQhjMCEYDjApAQyGApyBLgXXhTA5SEVIUVBQUBQAg8wErikP7a8AAAAASUVORK5CYII=) center center no-repeat;
    background-size: cover;
    cursor: pointer;
    border-radius: 0;
}
.q-custom-indices label span.checked {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAe1BMVEX//////v////39///c4Ond4ef+/v3e4OUnvE7d4OsovEwqvVDb4OnZ4Oip5Lj7/fr2/ffc3uri9ufA68pv04xOym1BxmQ7wV0uwFYlvEzw+vLs+fDp9u3c89/W893Q8NnN79ae4LCS3aWH2J131Ytr0Ydeznxhzns2wVy3gNuAAAAAsklEQVQY0y2PV3IEMQhEm0YgjSZsTs7Zvv8J3VO1/Kh4rUcB5hoxDLsotUTEVFENKrqBgHlFIAXS9BjBQIinSDoV+IRBDZnm2B4XWlkBqMgefsbbh4QdEyn2dGptXDwww/YH2vO5tesBLsVfLuPy9tf65RXrjMLv3m/X1s97M0NBYHMce2+nRybdBIz+ObbfrWJHSgHg71+bdHdAP2YDSHV0KVwXS4ciQgkk1BqTDi/3qv+EGQbH70lusQAAAABJRU5ErkJggg==)
}

.q-custom-indices .triangle {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 11px solid;
    border-color: transparent transparent transparent #d2d2d2;
    position: absolute;
    right: -22px;
    bottom: 10px;
    margin-top: -11px
}

.q-custom-indices .triangle:after {
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    position: absolute;
    border-left-color: #fff;
    border-right-width: 0;
    right: 1px;
    bottom: -10px
}
.q-custom-indices.form .label {
  min-width: 105px;
  text-align: left;
}

.indice-container .indice-trigger .fa {
    padding-right: 5px;
}

.right-tab .indice-container {
    margin: 0;
}
.right-tab .indice-trigger {
    display: block;
    box-sizing: border-box;
    cursor: pointer;
}

.right-tab .q-custom-indices {
    bottom: -6px;
}
.mgTop4 {
  margin-top: 4px;
}
.mgleft8 {
  margin-left: 8px;
}
</style>




// WEBPACK FOOTER //
// custom-indice.vue?fd00e706